import { NavLink } from "react-router";

function Home() {
  return (
    <section class="hero is-light is-fullheight">
      <div class="hero-body">
        <div class="container">
          <div class="columns">
            <div class="column is-norrow">
              <figure class="image">
                <img alt="" class="is-rounded" src="logo-lateral-v.png" style={{objectFit: "scale-down", height: "700px"}}/>
              </figure>
            </div>
            <div class="column">
              <div class="content">
                <h1 class="title">Maia Energia</h1>
                <h3 class="mt-3 mb-3">Energia barata e Inteligente</h3>
                <p>Você sabia que pode pagar menos pela sua energia elétrica sem abrir mão da qualidade? Com o nosso sistema, fornecedores competem entre si para oferecer o menor preço, e você sai ganhando.</p>

                <h3 class="subtitle mt-3 mb-0">Como Funciona</h3>
                <ol>
                  <li>Você se cadastra e informa seu consumo médio de energia.</li>
                  <li>Buscamos entre nossos fornecedores as melhores ofertas.</li>
                  <li>Escolha a proposta com o menor custo e melhores condições.</li>
                </ol>

                <h3 class="subtitle mt-5 mb-0">Vantagens</h3>
                <ul>
                  <li>Redução real na conta de energia</li>
                  <li>Processo automatizado e sem burocracia  </li>
                  <li>Transparência total nas ofertas</li>
                  <li>Energia limpa e de fontes certificadas</li>
                </ul>

                <h3 class="subtitle mt-5 mb-0">Para quem é</h3>
                <ul class="is-unstyled">
                  <li>Empresas que querem reduzir seus custos operacionais</li>
                  <li>Condomínios e indústrias com alto consumo energético</li>
                  <li>Consumidores que buscam liberdade de escolha e economia</li>
                </ul>

                <NavLink className="button is-warning " to="/order">Começar</NavLink>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

export default Home;
